import { DESKTOP_BREAKPOINT, HTML_WIDTH, TABLET_BREAKPOINT, TRIGGER_OVERLAY_ON_RELOAD_PAGE_ON_DESKTOP_BREAKPPOINT } from './default-variables';
// Tillfälligt avstängt. Sätt till true för att aktivera rabattmärken igen.
const DISCOUNT_BADGES_ENABLED = false;

const screen_is_used = HTML_WIDTH < DESKTOP_BREAKPOINT ? 'mobile' : 'desktop';

// laddar om sidan om breakpoint är passerad mobil <--> desktop
export function breakpoint_reload_page() {
  const screen_size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  //$('#PreLoad').addClass('resize');
  //$('#PreLoad').show();
  //$('#Header').hide();
  if (screen_is_used == 'mobile' && DESKTOP_BREAKPOINT <= screen_size) {
    if (TRIGGER_OVERLAY_ON_RELOAD_PAGE_ON_DESKTOP_BREAKPPOINT) {
      $('#PreLoad').css('display', 'block');
    }
    location.reload();
  } else if (screen_is_used == 'desktop' && screen_size < DESKTOP_BREAKPOINT) {
    if (TRIGGER_OVERLAY_ON_RELOAD_PAGE_ON_DESKTOP_BREAKPPOINT) {
      $('#PreLoad').css('display', 'block');
    }
    location.reload();
  }
}

// justerar width för dropdown-menyn från comboboxar -> ger samma width som förälder har
export function comboBox_width() {
  if ($('.form-group .comboBox').length) {
    $('.form-group .comboBox').each(function () {
      const width = $('input', this).outerWidth();
      $('.comboBoxDataContainer', this).css({ width: width, 'max-width': width });
    });
  }
}

export function createQuantityButton(type, label) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = `qty-btn qty-btn-${type}`;
  button.setAttribute('data-action', type);
  button.textContent = label;
  button.setAttribute('aria-label', `${type === 'plus' ? 'Increase' : 'Decrease'} quantity`);

  return button;
}

export function handleQuantityButtonClick(event) {
  const button = event.target.closest('.qty-btn');

  if (!button) return;

  event.preventDefault();

  const input = button.parentElement.querySelector('input[type="text"]');

  if (!input) return;

  const action = button.dataset.action;
  const currentValue = parseInt(input.value) || 0;
  const min = parseInt(input.getAttribute('min')) || 1;
  const max = parseInt(input.getAttribute('max')) || Infinity;

  let newValue = currentValue;

  if (action === 'plus' && currentValue < max) {
    newValue = currentValue + 1;
  } else if (action === 'minus' && currentValue > min) {
    newValue = Math.max(min, currentValue - 1);
  }

  if (newValue !== currentValue) {
    input.value = newValue;

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

let quantityButtonClickHandlerBound = false;

export function bindQuantityButtonClickHandler() {
  if (quantityButtonClickHandlerBound) return;
  quantityButtonClickHandlerBound = true;

  document.addEventListener('click', handleQuantityButtonClick);
}

export function initializeQuantityButtons(quantityGroupSelector = '.quantity', inputWrapperSelector = '.numeric') {
  const quantityGroups = document.querySelectorAll(quantityGroupSelector);

  quantityGroups.forEach((group) => {
    const inputWrapper = group.querySelector(inputWrapperSelector);
    const input = inputWrapper?.querySelector('input[type="text"]');

    if (!input || group.querySelector('.qty-btn')) return;

    const decrementBtn = createQuantityButton('minus', '');
    const incrementBtn = createQuantityButton('plus', '');

    inputWrapper.insertBefore(decrementBtn, input);
    inputWrapper.appendChild(incrementBtn);
  });
}

function createDiscountBadge(percent) {
  const badge = document.createElement('div');
  badge.className = 'wl-discount-badge';
  badge.innerHTML = `<span class="discount-value">-${percent}%</span>`;
  badge.setAttribute('aria-label', `${percent}% discount`);

  return badge;
}

function addDiscountBadgeToCrossItem(crossItem, originalPrice, salePrice) {
  if (crossItem.querySelector('.wl-discount-badge')) return;

  const salePriceValue = parseFloat(salePrice.replace(',', '.'));
  const regularPriceValue = parseFloat(originalPrice.replace(',', '.'));

  if (Number.isNaN(salePriceValue) || Number.isNaN(regularPriceValue) || salePriceValue >= regularPriceValue) return;

  const discountPercent = Math.round(((regularPriceValue - salePriceValue) / regularPriceValue) * 100);

  const innerContainer = crossItem.querySelector('.inner');
  if (!innerContainer) return;

  const badge = createDiscountBadge(discountPercent);
  badge.classList.add('wl-discount-badge-cross');

  innerContainer.appendChild(badge);
}

// Jävligt roundabout sätt att hämta originalpriset från produktsidan för cross selling items som är på rea för att kunna visa rabattmärke
function fetchAndAddDiscountBadge(crossItem) {
  if (crossItem.querySelector('.wl-discount-badge')) return;

  const salePrice = crossItem.querySelector('.price.sale .value');
  if (!salePrice) return;

  const salePriceText = salePrice.textContent.trim();

  const linkEl = crossItem.querySelector('.title.cross-name a');
  if (!linkEl) return;

  const productUrl = linkEl.getAttribute('href');
  if (!productUrl) return;

  fetch(productUrl)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const pricesContainer = doc.getElementById('ProductPrices');
      if (!pricesContainer) return;

      const priceElements = pricesContainer.querySelectorAll('.price:not(.sale)');
      for (const priceEl of priceElements) {
        const label = priceEl.querySelector('.label');

        if (label && label.textContent.trim() === 'Grundpris') {
          const value = priceEl.querySelector('.value');

          if (value) {
            const originalPrice = value.textContent.trim();
            addDiscountBadgeToCrossItem(crossItem, originalPrice, salePriceText);
          }

          break;
        }
      }
    })
    .catch((error) => {
      console.error('Kunde inte hämta pris för cross sell-item:', error);
    });
}

export function addDiscountBadgesToCrossSellingItems(rootEl = document) {
  if (!DISCOUNT_BADGES_ENABLED || !rootEl) return;

  const crossItems = rootEl.querySelectorAll('.cross-item.salesitem');
  crossItems.forEach((item) => {
    fetchAndAddDiscountBadge(item);
  });
}

export function addDiscountIndicators(rootEl = document) {
  if (!DISCOUNT_BADGES_ENABLED || !rootEl) return;

  const priceWrappers = rootEl.querySelectorAll('.price-wrapper');

  priceWrappers.forEach((wrapper) => {
    const salePrice = wrapper.querySelector('.price.sale .value');
    const regularPrice = wrapper.querySelector('.price:not(.sale) .value');

    if (!salePrice || !regularPrice) return;

    const salePriceValue = parseFloat(salePrice.textContent.trim().replace(',', '.'));
    const regularPriceValue = parseFloat(regularPrice.textContent.trim().replace(',', '.'));

    if (Number.isNaN(salePriceValue) || Number.isNaN(regularPriceValue) || salePriceValue >= regularPriceValue) return;

    const discountPercent = Math.round(((regularPriceValue - salePriceValue) / regularPriceValue) * 100);

    const buyInner = wrapper.closest('.buy-inner') ?? wrapper;

    const productItem = buyInner.closest('.product-item, .product, .cross-item, .productContainer');

    if (!productItem) return;

    if (productItem.querySelector('.discount-badge')) return;

    const imageWrapper = productItem.querySelector('.image-wrapper') ?? productItem.querySelector('.product-images') ?? productItem.querySelector('.image-inner') ?? productItem.querySelector('.image');

    const badgeHost = imageWrapper ?? productItem;

    if (!badgeHost) return;

    const badge = createDiscountBadge(discountPercent);
    badgeHost.appendChild(badge);
  });
}

// Mapping av svenska attributbilder -> engelska motsvarigheter
const ATTRIBUTE_IMAGE_MAP = {
  'marker-kampanj.png': 'marker-kampanj-en.png',
  'marker-nyhet.png': 'marker-nyhet-en.png',
  'marker-storsaljare.png': 'marker-storsaljare-en.png'
};

export function swapAttributeImagesForEnglish(rootEl = document) {
  if (!document.body.classList.contains('lang-en')) return;

  const images = (rootEl || document).querySelectorAll('.attribute-image img, .groupimage img');

  images.forEach((img) => {
    const src = img.getAttribute('src') || '';
    const filename = src.split('/').pop();

    if (ATTRIBUTE_IMAGE_MAP[filename]) {
      img.setAttribute('src', src.replace(filename, ATTRIBUTE_IMAGE_MAP[filename]));
    }
  });
}
